module.exports = __webpack_public_path__ + "f512d032f7333941da00a88ce66efb9d.svg";